import React from 'react';
import { Receipt } from 'lucide-react';
import { ExpenseReportsSettings } from './ExpenseReportsSettings';

export const NotesDeFraisPage: React.FC = () => {
    return (
        <div className="space-y-6">
            <header>
                <h1 className="text-3xl font-bold tracking-tight text-content flex items-center gap-2"><Receipt size={24} /> Notes de frais</h1>
                <p className="text-content-muted mt-1">Demandes de remboursement envoyées par vos salariés.</p>
            </header>
            <ExpenseReportsSettings />
        </div>
    );
};

export default NotesDeFraisPage;
